module.exports = __webpack_public_path__ + "img/ve_black.73405372.svg";